export const Images = {
    logo: {
        path: '/logos/spoferan/spoferan-full-logo.png',
        ratio: 1173 / 210
    },
    favicon: {
        path: '/logos/spoferan/spoferan-icon.png',
        ratio: 988 / 869
    },
    companyLogo: {
        path: '/logos/spoferan/spoferan-icon.png',
        ratio: 988 / 869
    },
    spoferan: {
        logo: {
            path: '/logos/spoferan/spoferan-full-logo.png',
            ratio: 1173 / 210
        },
        app: {
            path: '/logos/spoferan/spoferan-app-icon.png',
            ratio: 1024 / 1024
        },
        icon: {
            path: '/logos/spoferan/spoferan-icon.png',
            ratio: 988 / 869
        },
    },
    resultastic: {
        logo: {
            path: '/logos/resultastic-logo.png',
            ratio: 3085 / 756
        },
        favicon: {
            path: '/logos/resultastic-icon.png',
            ratio: 800 / 800
        },
    },
    clubmanager: {
        logo: {
            path: '/logos/clubmanager/spoferan-clubmanager-logo.png',
            ratio: 1376 / 358
        },
        favicon: {
            path: '/logos/clubmanager/spoferan-clubmanager-icon.png',
            ratio: 1000 / 1000
        },
    },
    businessmanager: {
        logo: {
            path: '/logos/businessmanager/spoferan-businessmanager-logo.png',
            ratio: 1903 / 383
        },
        favicon: {
            path: '/logos/businessmanager/spoferan-businessmanager-icon.png',
            ratio: 1000 / 1000
        },
    },
    garmin: {
        logo: {
            path: '/logos/garmin-connect-logo.png',
            ratio: 918 / 258
        },
        app: {
            path: '/logos/garmin-connect-app.png',
            ratio: 250 / 250
        },
    },
    suunto: {
        logo: {
            path: '/logos/suunto-logo.png',
            ratio: 918 / 514
        },
        app: {
            path: '/logos/suunto-app.png',
            ratio: 250 / 250
        },
    },
    btv: {
        logo: {
            path: '/logos/btv/btv-logo.png',
            ratio: 680 / 251
        },
        header: {
            path: '/logos/btv/btv-header.png',
            ratio: 2400 / 400
        }
    },
    countries: {
        worldwide: {
            path: 'countries/WW.png',
            ratio: 1
        }
    }
};
//# sourceMappingURL=images.js.map